import { GrowthBook } from "@growthbook/growthbook-react";

const growthbook = new GrowthBook({
  apiHost: process.env.NEXT_PUBLIC_GROWTHBOOK_BASE_URL,
  clientKey: process.env.NEXT_PUBLIC_GROWTHBOOK_SDK_KEY,
  enableDevMode: process.env.NEXT_PUBLIC_ACKO_ENV !== "prod",
  trackingCallback: (experiment, result) => {
    console.log("Experiment Viewed", {
      experimentId: experiment.key,
      variationId: result.key,
    });
  },
});

export const getFeatureValue = ({ flagName }: any) => {
  const flagValue = growthbook.isOn(flagName);
  return flagValue;
};

export const loadGrowthbookFeatures = (userId?: string ,city?: string) => {
  if (userId) {
    growthbook.setAttributes({
      id: userId,
      city: city
    });
  }

  return Promise.race([
    growthbook.loadFeatures(),
    new Promise((resolve) => {
      setTimeout(() => {
        resolve("fallback timeout executed");
      }, 600);
    }),
  ]);
};

export const isGrowthBookReady = () => {
  return growthbook.ready;
};

export default growthbook;
